// import { connect } from "react-redux";
import { compose } from "redux";
import {
  selectDailyTextsData,
  withDailyTextsData,
  withDailyTexts
} from "../../store/dailytexts";
// import {
//   TRACK_EDIT_DAYS,
//   TRACK_ADD_HOUR,
//   TRACK_DELETE_HOUR,
//   TRACK_EDIT_HOUR,
//   callOnlyOnce
// } from "../../store/mixpanel";

export default compose(
  withDailyTextsData,
  withDailyTexts
);

// export default connect(
//   selectDailyTextsData,
//   dispatch => {
//     const trackDays = callOnlyOnce(() => {
//       dispatch({
//         type: TRACK_EDIT_DAYS
//       });
//     });

//     return {
//       updateDts({ hours, days }) {
//         return dispatch(updateDts({ hours, days }));
//       },
//       setHours(hours, isEdited) {
//         dispatch({
//           type: isEdited ? TRACK_EDIT_HOUR : TRACK_ADD_HOUR,
//           payload: { hours }
//         });

//         return dispatch(setHours({ hours }));
//       },
//       removeHours(hours) {
//         dispatch({
//           type: TRACK_DELETE_HOUR,
//           payload: { hours }
//         });

//         return dispatch(removeHours({ hours }));
//       },
//       setDays(days) {
//         trackDays();
//         return dispatch(setDays({ days }));
//       },
//       createDays(days) {
//         trackDays();
//         return dispatch(createDays({ days }));
//       },
//       removeDays(days) {
//         trackDays();
//         return dispatch(removeDays({ days }));
//       }
//     };
//   }
// );



// WEBPACK FOOTER //
// ./src/routes/Home/connected.js